
<context-display :context="context">
  <template #simple>
    <p>{{displayName}}</p>
  </template>
  <template #workarea>
    Format: <strong>{{displayName}}</strong> &nbsp;
  </template>
</context-display>
